(function() {
  function countGroups(products, groups) {
    return groups.map(function(group) {
      var candidates = products.filter(function(product) {
        return groups.every(function(other) {
          return other.key === group.key || other.parent === group.key || !other.active || product[1].includes(other.active);
        });
      });
      var values = {};
      var available = {};
      group.values.forEach(function(value) {
        values[value] = candidates.filter(function(product) { return product[1].includes(value); }).length;
        available[value] = products.some(function(product) { return product[1].includes(value); });
      });
      return { key: group.key, total: candidates.length, values: values, available: available };
    });
  }

  async function loadRows(endpoint, collectionId, fetchPage) {
    var url = new URL(endpoint);
    var products = [];
    var seen = new Set();
    var total = null;
    var pages = null;
    for (var pageNumber = 1; pages === null || pageNumber <= pages; pageNumber += 1) {
      url.searchParams.set('page', String(pageNumber));
      var data = await fetchPage(url.toString());
      if (data.collection !== collectionId || data.page !== pageNumber || !Number.isInteger(data.total) ||
          data.total < 0 || data.total > 25000 || !Number.isInteger(data.pages) || data.pages < 0 ||
          data.pages > 100 || !Array.isArray(data.products) || data.products.length > 250) {
        throw new Error('Invalid collection count response');
      }
      if (total === null) {
        total = data.total;
        pages = data.pages;
      } else if (data.total !== total || data.pages !== pages) {
        throw new Error('Collection changed during count loading');
      }
      data.products.forEach(function(product) {
        if (!Array.isArray(product) || typeof product[0] !== 'string' || !Array.isArray(product[1]) ||
            !product[1].every(function(tag) { return typeof tag === 'string'; }) || seen.has(product[0])) {
          throw new Error('Invalid or duplicate collection product');
        }
        seen.add(product[0]);
        products.push(product);
      });
    }
    if (products.length !== total) throw new Error('Incomplete collection count response');
    return products;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { countGroups: countGroups, loadRows: loadRows };
  }
  if (typeof document === 'undefined' || window.daceinFilterCountsReady) return;
  window.daceinFilterCountsReady = true;

  var requests = new Map();

  async function fetchPage(url) {
    var controller = new AbortController();
    var timer = window.setTimeout(function() { controller.abort(); }, 15000);
    try {
      var response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection counts unavailable');
      return await response.json();
    } finally {
      window.clearTimeout(timer);
    }
  }

  async function updateFilter(filter) {
    if (filter.dataset.countState) return;
    var query = new URLSearchParams(window.location.search);
    ['page', 'part', 'view', 'section_id', 'sections'].forEach(function(key) { query.delete(key); });
    if (filter.dataset.qualityResetUrl) {
      var resetUrl = new URL(filter.dataset.qualityResetUrl, window.location.origin);
      resetUrl.search = query.toString();
      window.location.replace(resetUrl.toString());
      return;
    }
    filter.dataset.countState = 'loading';
    filter.setAttribute('aria-busy', 'true');
    var groups = Array.from(filter.querySelectorAll('[data-count-group]')).map(function(element) {
      return {
        key: element.dataset.countGroup,
        active: element.dataset.countActive,
        parent: element.dataset.countParent,
        values: Array.from(element.querySelectorAll('[data-count-value]')).map(function(link) {
          return link.dataset.countValue;
        }).filter(Boolean)
      };
    });
    filter.querySelectorAll('a').forEach(function(link) {
      var destination = new URL(link.href);
      destination.search = query.toString();
      link.href = destination.toString();
    });
    var endpoint = new URL(filter.dataset.countUrl, window.location.origin);
    endpoint.search = query.toString();
    endpoint.searchParams.set('view', 'filter-data');
    var key = endpoint.toString();
    try {
      var cached = requests.get(key);
      if (!cached || Date.now() - cached.created > 30000) {
        cached = { created: Date.now(), promise: loadRows(key, filter.dataset.countCollection, fetchPage) };
        requests.set(key, cached);
      }
      var products = await cached.promise;
      if (!filter.isConnected) return;
      var counts = countGroups(products, groups);
      counts.forEach(function(count, index) {
        var group = filter.querySelectorAll('[data-count-group]')[index];
        var hasOptions = false;
        group.querySelectorAll('[data-count-value]').forEach(function(link) {
          var value = link.dataset.countValue;
          var visible = !value || count.available[value] || value === groups[index].active;
          if (value && visible) hasOptions = true;
          link.style.display = visible ? '' : 'none';
          var number = link.querySelector('small');
          number.textContent = value ? count.values[value] : count.total;
          number.style.display = '';
        });
        group.style.display = hasOptions ? '' : 'none';
      });
      filter.dataset.countState = 'ready';
    } catch (error) {
      requests.delete(key);
      filter.dataset.countState = 'error';
    } finally {
      filter.setAttribute('aria-busy', 'false');
    }
  }

  function initFilters() {
    document.querySelectorAll('[data-b2b-collection-filters][data-count-url]').forEach(updateFilter);
  }

  initFilters();
  new MutationObserver(function(records) {
    if (records.some(function(record) {
      return Array.from(record.addedNodes).some(function(node) {
        return node.nodeType === 1 && (node.matches('[data-b2b-collection-filters]') ||
          node.querySelector('[data-b2b-collection-filters]'));
      });
    })) initFilters();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();